import React, { FC, ReactElement } from 'react';
import { DestinationEditConfigurationTablesSkeletonsContainer } from './skeletons.styles';
import CheckboxTableSkeleton from 'src/products/connector/pages/add-connector/panels/Destination/CheckboxTableSkeleton';

const DestinationEditConfigurationTablesSkeletons: FC = (): ReactElement => {
  return (
    <DestinationEditConfigurationTablesSkeletonsContainer>
      <CheckboxTableSkeleton />
    </DestinationEditConfigurationTablesSkeletonsContainer>
  );
};

export default DestinationEditConfigurationTablesSkeletons;
